import { Routes } from '@angular/router';
import {
  CmsPageComponent,
  cmsPageTemplateResolver,
  cmsSeoDataResolver,
} from '@domgen/dgx-fe-cms';
import { SupportGaCategory } from '@support/util-models';

export const CONTACT_US_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      gaData: {
        eventCategory: SupportGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
      seoData: cmsSeoDataResolver,
    },
  },
];
